<div class="app-space-around">
  <span class="custom-message sp-top-margin-4">{{message}}</span>
  <span class="ok-class" (click)=dismissToastr()>OK</span>
</div>